export default __webpack_public_path__ + "static/news-8a6f20fad6c84728ef1b6c6b27dbf458.jpg";